export default "__VITE_ASSET__f856afab__"